import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { catchError, tap } from "rxjs/operators";
import { Router } from "@angular/router";
import { environment } from "@environments/environment";
import { TokenService } from '@services/rest/token.service';

@Injectable()
export class ApiInterceptor implements HttpInterceptor {
  static router: Router;

  BASE_URL: string = environment.apiEndpoint;

  constructor(private router: Router,
    private tokenService: TokenService) {
    ApiInterceptor.router = router;
  }

  token: string = "";
  // authUserState: AuthUserState;
  intercept(
    request: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    request = request.clone({
      url: this.BASE_URL + request.url,
      headers: request.headers
      .set('Cache-Control', 'no-cache')
      .set('Pragma', 'no-cache')
      .set('Expires', 'Sat, 01 Jan 2000 00:00:00 GMT')
      .set('Authorization', `Bearer ${this.tokenService.getAccessToken()}`)
    });

    // ApiInterceptor.store
    //   .select(AuthUserStateSelector.authUserState)
    //   .subscribe((authUserState) => {
    //     this.authUserState = authUserState;
    //   });

    // if (this.authUserState.isAuthenticated) {
    //   const { accessToken } = this.authUserState.authUserModel;
    // }


    return next.handle(request);
  }
}
